var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { actions } from '../Slice/ChatbotV2Slice';
import { actions as helperActions } from '../Slice/HelperSlice';
import { API } from '../Utils/Constants';
import { call, delay, fork, put, takeEvery, takeLatest, takeLeading, } from 'redux-saga/effects';
import _ from 'lodash';
import { getResultArray, handleException, valueToObject } from '../Utils/UtilityFunctions';
import { Base64 } from 'js-base64';
import axios from '../Utils/Axios';
export function getConversations(dispatched) {
    var payload, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, call(axios.post, API.GET_CONVERSATIONS, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(actions.setConversations({
                        sections: response === null || response === void 0 ? void 0 : response.response[0].sections,
                        offset: payload === null || payload === void 0 ? void 0 : payload.offset,
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                err_1 = _a.sent();
                console.log(err_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function deleteConversation(dispatched) {
    var payload, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.DELETE_CONVERSATION, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setDeleteConversation(payload.channelId))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Chat deleted successfully',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_2 = _a.sent();
                console.log(err_2);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function getPromptCategories(dispatched) {
    var payload, response, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 8]);
                return [4 /*yield*/, call(axios.post, API.PROMPT_CATEGORIES, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 6];
                if (!payload.isCustomCategory) return [3 /*break*/, 4];
                return [4 /*yield*/, put(actions.setCustomPromptCategories(response === null || response === void 0 ? void 0 : response.response))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(actions.setPromptCategories(response === null || response === void 0 ? void 0 : response.response))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                err_3 = _a.sent();
                console.log(err_3);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function getPrompts(dispatched) {
    var payload, response, params, prompts, data, err_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = dispatched.payload;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 8]);
                return [4 /*yield*/, call(axios.post, API.PROMPTS, payload)];
            case 2:
                response = _b.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 6];
                if (!payload.categoryId) return [3 /*break*/, 4];
                params = {
                    offset: payload.offset,
                    totalPrompts: (_a = response === null || response === void 0 ? void 0 : response.response[0]) === null || _a === void 0 ? void 0 : _a.totalPrompts,
                    data: response === null || response === void 0 ? void 0 : response.response[0].prompts,
                };
                return [4 /*yield*/, put(actions.setPrompts(params))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                prompts = response === null || response === void 0 ? void 0 : response.response[0].prompts;
                data = prompts === null || prompts === void 0 ? void 0 : prompts.map(function (prompt) { return ({
                    prompt: prompt,
                    promptId: 0,
                }); });
                return [4 /*yield*/, put(actions.setPrompts({ data: data }))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                err_4 = _b.sent();
                console.log(err_4);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function editConversation(dispatched) {
    var payload, response, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.EDIT_CONVERSATION, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setEditConversation(payload))];
            case 3:
                _a.sent();
                if (!(payload === null || payload === void 0 ? void 0 : payload.channelId)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setConvoToLatest(payload === null || payload === void 0 ? void 0 : payload.channelId))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_5 = _a.sent();
                console.log(err_5);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function chatbot(dispatched) {
    var payload, id, updatedPayload, response, taggedCompanies, taggedDocuments, taggedGroups, taggedPersons, prompt_1, regenerate, _a, popupText, showPlanPopup, callToAction, contactUsEmail, data, chat, cArray, dArray, gArray, pArray, final, data, err_6;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                payload = dispatched.payload;
                id = payload.id, updatedPayload = __rest(payload, ["id"]);
                _e.label = 1;
            case 1:
                _e.trys.push([1, 15, , 17]);
                return [4 /*yield*/, call(axios.post, API.CHATBOT, updatedPayload)];
            case 2:
                response = _e.sent();
                taggedCompanies = updatedPayload.taggedCompanies, taggedDocuments = updatedPayload.taggedDocuments, taggedGroups = updatedPayload.taggedGroups, taggedPersons = updatedPayload.taggedPersons, prompt_1 = updatedPayload.prompt, regenerate = updatedPayload.regenerate;
                if (!(((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.popupText) && ((_c = response === null || response === void 0 ? void 0 : response.response) === null || _c === void 0 ? void 0 : _c.showPlanPopup))) return [3 /*break*/, 4];
                _a = response.response, popupText = _a.popupText, showPlanPopup = _a.showPlanPopup, callToAction = _a.callToAction, contactUsEmail = _a.contactUsEmail;
                data = {
                    popupText: popupText,
                    showPlanPopup: showPlanPopup,
                    callToAction: callToAction || '',
                    contactUsEmail: contactUsEmail || '',
                };
                return [4 /*yield*/, put(actions.setChatbotPopup(data))];
            case 3:
                _e.sent();
                return [3 /*break*/, 14];
            case 4:
                chat = response.response.result;
                cArray = getResultArray(taggedCompanies !== null && taggedCompanies !== void 0 ? taggedCompanies : '', 'company');
                dArray = getResultArray(taggedDocuments !== null && taggedDocuments !== void 0 ? taggedDocuments : '', 'document');
                gArray = getResultArray(taggedGroups !== null && taggedGroups !== void 0 ? taggedGroups : '', 'group');
                pArray = getResultArray(taggedPersons !== null && taggedPersons !== void 0 ? taggedPersons : '', 'person');
                final = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], cArray, true), dArray, true), pArray, true), gArray, true).join(',');
                if (!((response === null || response === void 0 ? void 0 : response.status) === true && ((_d = chat[0]) === null || _d === void 0 ? void 0 : _d.responseId))) return [3 /*break*/, 11];
                data = {
                    chat: chat,
                    id: id,
                    isNewChat: !(payload === null || payload === void 0 ? void 0 : payload.channelId),
                    channelId: response.response.channelId || (payload === null || payload === void 0 ? void 0 : payload.channelId),
                    channelHeading: Base64.decode(payload.prompt),
                    image: payload.avatarImage,
                    color: payload.avatarColor,
                    source: payload.source,
                };
                return [4 /*yield*/, put(actions.setChat(data))];
            case 5:
                _e.sent();
                if (!(payload === null || payload === void 0 ? void 0 : payload.channelId)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(actions.setConvoToLatest(payload === null || payload === void 0 ? void 0 : payload.channelId))];
            case 6:
                _e.sent();
                _e.label = 7;
            case 7: return [4 /*yield*/, put(helperActions.callFlurryEvent(valueToObject('xcgpt_generate_successful', 0, {
                    tags_input: final,
                    search_query: prompt_1,
                })))];
            case 8:
                _e.sent();
                if (!(regenerate === 1)) return [3 /*break*/, 10];
                return [4 /*yield*/, put(helperActions.callFlurryEvent(valueToObject('xcgpt_regenerate_complete', 0, {
                        tags_input: final,
                        search_query: prompt_1,
                    })))];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [3 /*break*/, 14];
            case 11: return [4 /*yield*/, put(helperActions.callFlurryEvent(valueToObject('xcgpt_generate_failure', 0, {
                    tags_input: final,
                    search_query: prompt_1,
                })))];
            case 12:
                _e.sent();
                return [4 /*yield*/, put(actions.setChatLoading(false))];
            case 13:
                _e.sent();
                handleException();
                _e.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                err_6 = _e.sent();
                return [4 /*yield*/, put(actions.setChatLoading(false))];
            case 16:
                _e.sent();
                handleException();
                console.log(err_6);
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
export function getChatHistory(dispatched) {
    var payload, response, chat, err_7;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = dispatched.payload;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.CHATBOT_HISTORY, payload)];
            case 2:
                response = _b.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                chat = {
                    chat: (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.result,
                };
                return [4 /*yield*/, put(actions.setChat(chat))];
            case 3:
                _b.sent();
                if (!((payload === null || payload === void 0 ? void 0 : payload.offset) === 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setConversationFlag(true))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_7 = _b.sent();
                console.log(err_7);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function sendFeedback(dispatched) {
    var payload, response, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.CHAT_FEEDBACK, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setFeedbackSubmitted(payload === null || payload === void 0 ? void 0 : payload.responseId))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Feedback Recieved',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_8 = _a.sent();
                console.log(err_8);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function editChatResponse(dispatched) {
    var payload, response, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 8]);
                return [4 /*yield*/, call(axios.post, API.EDIT_CHAT, payload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(actions.updateChatResponse(payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(actions.setEditChatLoading(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                err_9 = _a.sent();
                console.log(err_9);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function globalSearchResults(dispatched) {
    var refinedQuery, response, results, err_10;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                refinedQuery = __assign({}, dispatched.payload);
                return [4 /*yield*/, call(axios.post, API.GLOBAL_SEARCH_RESULTS, refinedQuery)];
            case 1:
                response = _b.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 3];
                results = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.searchResult;
                return [4 /*yield*/, put(actions.globalSearchResultsLoaded(results))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(actions.globalSearchResultsError())];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_10 = _b.sent();
                console.log(err_10);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function deleteChat(dispatched) {
    var payload, isStopGenerating, updatedPayload, response, err_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = dispatched.payload;
                isStopGenerating = payload.isStopGenerating, updatedPayload = __rest(payload, ["isStopGenerating"]);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.CLEAR_CHAT_HISTORY, updatedPayload)];
            case 2:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.setDeleteChat(payload === null || payload === void 0 ? void 0 : payload.chatIds))];
            case 3:
                _a.sent();
                if (!!isStopGenerating) return [3 /*break*/, 5];
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Prompt deleted successfully',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_11 = _a.sent();
                console.log(err_11);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function personLinkedinSearch(dispatched) {
    var response, err_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.GET_PERSON_EXTENDED_SEARCH, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _a.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === true)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.personLinkedinSearch(response === null || response === void 0 ? void 0 : response.response))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(actions.globalSearchResultsError())];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_12 = _a.sent();
                console.log(err_12);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function getSearchResultsFlow(dispatched) {
    var query, querySplit, isDetailedSearch, isCompanySearch, isGroupSearch, isDocumentSearch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = dispatched.payload.query;
                querySplit = query.split(':');
                isDetailedSearch = querySplit.length > 1;
                isCompanySearch = false;
                isGroupSearch = false;
                isDocumentSearch = false;
                if (isDetailedSearch) {
                    isCompanySearch = querySplit[0].includes('company');
                    isGroupSearch = querySplit[0].includes('group');
                    isDocumentSearch = querySplit[0].includes('document');
                }
                return [4 /*yield*/, fork(globalSearchResults, dispatched)];
            case 1:
                _a.sent();
                return [4 /*yield*/, delay(200)];
            case 2:
                _a.sent();
                if (!(!isGroupSearch && !isCompanySearch && !isDocumentSearch)) return [3 /*break*/, 4];
                return [4 /*yield*/, fork(personLinkedinSearch, dispatched)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export function getPersonProfile(dispatched) {
    var payload, parameters, response, executiveId, color, personName, personImage, taggedItem, err_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, , 9]);
                payload = dispatched.payload;
                parameters = __assign({}, payload);
                if ('source' in parameters) {
                    _.unset(parameters, 'source');
                }
                if ('entityName' in parameters) {
                    _.unset(parameters, 'entityName');
                }
                return [4 /*yield*/, call(axios.post, API.GET_PERSON_PROFILE_DATA, parameters)];
            case 1:
                response = _a.sent();
                if (!(response.status === true)) return [3 /*break*/, 5];
                return [4 /*yield*/, delay(2000)];
            case 2:
                _a.sent();
                executiveId = 'personId' in response.response.result[1].details[0] ? response.response.result[1].details[0].personId : 0;
                color = 'archeType' in response.response.result[1].details[0] ? response.response.result[1].details[0].archeType.color : '';
                personName = 'personName' in response.response.result[1].details[0] ? response.response.result[1].details[0].personName : '';
                personImage = 'personImage' in response.response.result[1].details[0] ? response.response.result[1].details[0].personImage : '';
                return [4 /*yield*/, put(actions.setLivePersonTag({
                        livesearchId: payload.personId,
                        executiveId: 'personId' in response.response.result[1].details[0] ? response.response.result[1].details[0].personId : 0,
                        color: 'archeType' in response.response.result[1].details[0] ? response.response.result[1].details[0].archeType.color : '',
                    }))];
            case 3:
                _a.sent();
                taggedItem = {
                    type: 'person',
                    id: executiveId,
                    name: personName,
                    image: personImage,
                    color: color,
                    personType: 'EXECUTIVE',
                };
                return [4 /*yield*/, put(actions.changeOrderRecentTags([taggedItem]))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(actions.setPersonCardLoading(false))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                err_13 = _a.sent();
                console.log(err_13);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function personSetup(dispatched) {
    var response, err_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.PERSON_SETUP, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                if (!response.status) return [3 /*break*/, 3];
                return [4 /*yield*/, delay(2000)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, put(actions.setTagSetupLoading(false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_14 = _a.sent();
                console.log(err_14);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function groupSetup(dispatched) {
    var response, err_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.GROUP_SETUP, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                if (!response.status) return [3 /*break*/, 3];
                return [4 /*yield*/, delay(2000)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, put(actions.setTagSetupLoading(false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_15 = _a.sent();
                console.log(err_15);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function companySetup(dispatched) {
    var response, err_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.COMPANY_SETUP, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                if (!response.status) return [3 /*break*/, 3];
                return [4 /*yield*/, delay(2000)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, put(actions.setTagSetupLoading(false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_16 = _a.sent();
                console.log(err_16);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function recentTags() {
    var response, err_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, call(axios.post, API.RECENT_TAGS, {})];
            case 1:
                response = _a.sent();
                if (!response.status) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.recentTags(response))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_17 = _a.sent();
                console.log(err_17);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function getFavoritePrompts(dispatched) {
    var response, params, err_18;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, , 6]);
                return [4 /*yield*/, call(axios.post, API.FAVORITE_PROMPTS, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _d.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 4];
                params = {
                    data: (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.userFavouritesPrompts,
                    offset: (_b = dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload) === null || _b === void 0 ? void 0 : _b.offset,
                };
                return [4 /*yield*/, put(actions.setPrompts(params))];
            case 2:
                _d.sent();
                return [4 /*yield*/, put(actions.setFavPromptCount((_c = response === null || response === void 0 ? void 0 : response.response) === null || _c === void 0 ? void 0 : _c.totalFavouritesPrompt))];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                err_18 = _d.sent();
                console.log(err_18);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function markFavoritePrompt(dispatched) {
    var _a, isUndo, payload, response, _b, promptId, chatId, isFavourite, _c, prompt_2, resPropmtId, resChatId, categories, err_19;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = dispatched.payload, isUndo = _a.isUndo, payload = __rest(_a, ["isUndo"]);
                _d.label = 1;
            case 1:
                _d.trys.push([1, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.MARK_FAVORITE, payload)];
            case 2:
                response = _d.sent();
                _b = dispatched.payload, promptId = _b.promptId, chatId = _b.chatId, isFavourite = _b.isFavourite;
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 5];
                _c = response.response, prompt_2 = _c.prompt, resPropmtId = _c.promptId, resChatId = _c.chatId, categories = _c.categories;
                return [4 /*yield*/, put(actions.setMarkFavoritePrompt({
                        chatId: chatId || resChatId,
                        promptId: promptId || resPropmtId,
                        isFavourite: isFavourite,
                        prompt: prompt_2,
                        categories: categories,
                    }))];
            case 3:
                _d.sent();
                if (!isUndo) return [3 /*break*/, 5];
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Action undone: Prompt re-added to My Favorites',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                        className: 'fav-prompt',
                    }))];
            case 4:
                _d.sent();
                _d.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_19 = _d.sent();
                console.log(err_19);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function getGilroyData() {
    var response, err_20;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, call(axios.post, API.GILROY_DATA, {})];
            case 1:
                response = _a.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.setGilroyData(response === null || response === void 0 ? void 0 : response.response))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_20 = _a.sent();
                console.log(err_20);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function addRemovePromptFromCategory(dispatched) {
    var response, _a, chatId, newCategory, categoryIds, deleteSinglePrompt, host, err_21;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 21, , 22]);
                return [4 /*yield*/, call(axios.post, API.ADD_REMOVE_PROMPT, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _e.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 16];
                _a = dispatched.payload, chatId = _a.chatId, newCategory = _a.newCategory, categoryIds = _a.categoryIds, deleteSinglePrompt = _a.deleteSinglePrompt;
                if (!chatId) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.setNewPromptFromCategory(__assign(__assign({}, response === null || response === void 0 ? void 0 : response.response), { chatId: chatId })))];
            case 2:
                _e.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(actions.setAddRemovePromptFromCategory(response === null || response === void 0 ? void 0 : response.response))];
            case 4:
                _e.sent();
                _e.label = 5;
            case 5:
                if (!!newCategory) return [3 /*break*/, 12];
                if (!deleteSinglePrompt) return [3 /*break*/, 7];
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Prompt has been successfully deleted',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 6:
                _e.sent();
                return [3 /*break*/, 11];
            case 7:
                if (!!(categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length)) return [3 /*break*/, 9];
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Prompt has been successfully deleted from selected categories.',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 8:
                _e.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, put(helperActions.setNotification({
                    message: 'Prompt library has been successfully updated',
                    proTip: false,
                    rightPlacement: false,
                    groupId: 0,
                    classnameFlag: true,
                    getContainerEle: 'chatContainer',
                }))];
            case 10:
                _e.sent();
                _e.label = 11;
            case 11: return [3 /*break*/, 15];
            case 12:
                host = window.location.href;
                return [4 /*yield*/, put(helperActions.callFlurryEvent(valueToObject('category_created', 0, {
                        host: host,
                    })))];
            case 13:
                _e.sent();
                return [4 /*yield*/, put(helperActions.callFlurryEvent(valueToObject('prompt_added', 0, {
                        host: host,
                    })))];
            case 14:
                _e.sent();
                _e.label = 15;
            case 15: return [3 /*break*/, 20];
            case 16:
                if (!!((_b = dispatched.payload) === null || _b === void 0 ? void 0 : _b.newCategory)) return [3 /*break*/, 18];
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: ((_c = response === null || response === void 0 ? void 0 : response.response) === null || _c === void 0 ? void 0 : _c.error) || 'Something went wrong. Please try again',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: false,
                        getContainerEle: 'chatContainer',
                    }))];
            case 17:
                _e.sent();
                return [3 /*break*/, 20];
            case 18: return [4 /*yield*/, put(actions.setAddRemovePromptError(((_d = response === null || response === void 0 ? void 0 : response.response) === null || _d === void 0 ? void 0 : _d.error) || ''))];
            case 19:
                _e.sent();
                _e.label = 20;
            case 20: return [3 /*break*/, 22];
            case 21:
                err_21 = _e.sent();
                console.log(err_21);
                return [3 /*break*/, 22];
            case 22: return [2 /*return*/];
        }
    });
}
export function editCustomCategory(dispatched) {
    var response, _a, categoryId, categoryName, categoryDescription, data, err_22;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 7]);
                return [4 /*yield*/, call(axios.post, API.EDIT_CATEGORY, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _c.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 3];
                _a = dispatched.payload, categoryId = _a.categoryId, categoryName = _a.categoryName, categoryDescription = _a.categoryDescription;
                data = {
                    categoryId: categoryId,
                    title: categoryName,
                    description: categoryDescription || '',
                };
                return [4 /*yield*/, put(actions.setEditCustomCategory(data))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(actions.setAddRemovePromptError(((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.error) || ''))];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                err_22 = _c.sent();
                console.log(err_22);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function deleteCustomCategory(dispatched) {
    var response, err_23;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                return [4 /*yield*/, call(axios.post, API.DELETE_CATEGORY, dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload)];
            case 1:
                response = _b.sent();
                if (!(response === null || response === void 0 ? void 0 : response.status)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(actions.setDeleteCustomCategory((_a = dispatched === null || dispatched === void 0 ? void 0 : dispatched.payload) === null || _a === void 0 ? void 0 : _a.categoryId))];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(helperActions.setNotification({
                        message: 'Category has been deleted successfully',
                        proTip: false,
                        rightPlacement: false,
                        groupId: 0,
                        classnameFlag: true,
                        getContainerEle: 'chatContainer',
                    }))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                err_23 = _b.sent();
                console.log(err_23);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function ChatBotV2Saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.getConversations, getConversations)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteConversation, deleteConversation)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getPromptCategories, getPromptCategories)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getPrompts, getPrompts)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.editConversation, editConversation)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.chatbot, chatbot)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getChatHistory, getChatHistory)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.sendFeedback, sendFeedback)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.editChatResponse, editChatResponse)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.globalSearchResults, getSearchResultsFlow)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteChat, deleteChat)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLeading(actions.tagLiveSearchPerson, getPersonProfile)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.personSetup, personSetup)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.companySetup, companySetup)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.groupSetup, groupSetup)];
            case 15:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getRecentTags, recentTags)];
            case 16:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getFavoritePrompts, getFavoritePrompts)];
            case 17:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.markFavoritePrompt, markFavoritePrompt)];
            case 18:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getGilroyData, getGilroyData)];
            case 19:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.addRemovePromptFromCategory, addRemovePromptFromCategory)];
            case 20:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.editCustomCategory, editCustomCategory)];
            case 21:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteCustomCategory, deleteCustomCategory)];
            case 22:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
